(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[378],{

/***/ 91509:
/***/ (function(module) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 91509;
module.exports = webpackEmptyAsyncContext;

/***/ }),

/***/ 75974:
/***/ (function(module) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 75974;
module.exports = webpackEmptyAsyncContext;

/***/ }),

/***/ 25963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ ScannerType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _util_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16772);
/* harmony import */ var lib_chains__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90380);



var ScannerType;
(function(ScannerType) {
    ScannerType[ScannerType["Address"] = 0] = "Address";
    ScannerType[ScannerType["Tx"] = 1] = "Tx";
    ScannerType[ScannerType["Block"] = 2] = "Block";
    ScannerType[ScannerType["BeaconSlot"] = 3] = "BeaconSlot";
})(ScannerType || (ScannerType = {}));
const ScannerLink = (param)=>{
    let { value , chain , type , shorten: shortenAddress = false  } = param;
    let url = undefined;
    let parsedValue = value;
    if (chain !== undefined) {
        url = "";
        if (type === ScannerType.Address) {
            var ref;
            parsedValue = value.length === 42 ? value : "0x" + value.slice(26);
            url = ((ref = lib_chains__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP[chain]) === null || ref === void 0 ? void 0 : ref.scanUrl) + "address/";
        } else if (type === ScannerType.Tx) {
            var ref1;
            url = ((ref1 = lib_chains__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP[chain]) === null || ref1 === void 0 ? void 0 : ref1.scanUrl) + "tx/";
        } else if (type === ScannerType.Block) {
            var ref2;
            url = ((ref2 = lib_chains__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP[chain]) === null || ref2 === void 0 ? void 0 : ref2.scanUrl) + "block/";
        } else {
            if (chain === "gnosis") {
                var ref3;
                // Gnosis uses old beaconcha.in version
                url = (((ref3 = lib_chains__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP[chain]) === null || ref3 === void 0 ? void 0 : ref3.beaconScanUrl) || "") + "block/";
            } else {
                var ref4;
                url = (((ref4 = lib_chains__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP[chain]) === null || ref4 === void 0 ? void 0 : ref4.beaconScanUrl) || "") + "slot/";
            }
        }
        url += parsedValue;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: url,
        className: "font-mono text-succinct-teal-50 hover:underline",
        title: value,
        target: "_blank",
        rel: "noreferrer",
        children: shortenAddress ? (0,_util_util__WEBPACK_IMPORTED_MODULE_1__/* .shorten */ .OV)(parsedValue, 6, 4) : parsedValue
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScannerLink);


/***/ }),

/***/ 30921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ graphSDK; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@graphql-mesh/utils/esm/parseAndPrintWithCache.js
var parseAndPrintWithCache = __webpack_require__(47883);
// EXTERNAL MODULE: ./node_modules/@graphql-mesh/utils/esm/pubsub.js
var esm_pubsub = __webpack_require__(20112);
// EXTERNAL MODULE: ./node_modules/@graphql-mesh/utils/esm/logger.js
var esm_logger = __webpack_require__(42823);
// EXTERNAL MODULE: ./node_modules/@graphql-mesh/cache-localforage/esm/index.js + 1 modules
var esm = __webpack_require__(60594);
// EXTERNAL MODULE: ./node_modules/@whatwg-node/fetch/dist/global-ponyfill.js
var global_ponyfill = __webpack_require__(59102);
// EXTERNAL MODULE: ./node_modules/@graphql-mesh/graphql/esm/index.js + 44 modules
var graphql_esm = __webpack_require__(2385);
// EXTERNAL MODULE: ./node_modules/@graphql-mesh/merger-bare/esm/index.js + 62 modules
var merger_bare_esm = __webpack_require__(13401);
// EXTERNAL MODULE: ./node_modules/@graphql-mesh/runtime/esm/get-mesh.js + 19 modules
var get_mesh = __webpack_require__(84887);
// EXTERNAL MODULE: ./node_modules/@graphql-mesh/store/esm/index.js + 3 modules
var store_esm = __webpack_require__(73013);
// EXTERNAL MODULE: ./node_modules/path-browserify/index.js
var path_browserify = __webpack_require__(26470);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
// EXTERNAL MODULE: ./node_modules/@graphql-mesh/utils/esm/fileURLToPath.js
var fileURLToPath = __webpack_require__(77405);
;// CONCATENATED MODULE: ./.graphclient/index.ts
// @ts-nocheck

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSentMessageByMessageNumber($num: BigInt) {\n  sentMessages(where: {messageNonce: $num}) {\n    id\n    version\n    msgHash\n    message\n    messageData\n    blockNumber\n    blockTimestamp\n    messageNonce\n    messageReceiver\n    messageReceiverChainID\n    messageSender\n    messageSenderChainID\n    transactionHash\n    transactionOrigin\n  }\n}\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSentMessageByTransactionHash($hash: Bytes) {\n  sentMessages(where: {transactionHash: $hash}) {\n    id\n    version\n    msgHash\n    message\n    messageData\n    blockNumber\n    blockTimestamp\n    messageNonce\n    messageReceiver\n    messageReceiverChainID\n    messageSender\n    messageSenderChainID\n    transactionHash\n    transactionOrigin\n  }\n}\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSentMessageByMessageHash($hash: Bytes) {\n  sentMessages(where: {msgHash: $hash}) {\n    id\n    version\n    msgHash\n    message\n    messageData\n    blockNumber\n    blockTimestamp\n    messageNonce\n    messageReceiver\n    messageReceiverChainID\n    messageSender\n    messageSenderChainID\n    transactionHash\n    transactionOrigin\n  }\n}\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSentMessages($where: SentMessage_filter, $skip: Int, $count: Int) {\n  sentMessages(\n    where: $where\n    skip: $skip\n    first: $count\n    orderBy: messageNonce\n    orderDirection: desc\n  ) {\n    id\n    version\n    msgHash\n    message\n    messageData\n    blockNumber\n    blockTimestamp\n    messageNonce\n    messageReceiver\n    messageReceiverChainID\n    messageSender\n    messageSenderChainID\n    transactionHash\n    transactionOrigin\n  }\n}\n    "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetExecutedMessages($where: ExecutedMessage_filter, $skip: Int, $count: Int) {\n  executedMessages(\n    where: $where\n    skip: $skip\n    first: $count\n    orderBy: messageNonce\n    orderDirection: desc\n  ) {\n    id\n    version\n    msgHash\n    message\n    messageData\n    blockNumber\n    blockTimestamp\n    messageNonce\n    messageReceiver\n    messageReceiverChainID\n    messageSender\n    messageSenderChainID\n    transactionHash\n    transactionOrigin\n    status\n  }\n}\n    "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetExecutedMessageByMessageNumber($num: BigInt) {\n  executedMessages(where: {messageNonce: $num}) {\n    id\n    version\n    msgHash\n    message\n    messageData\n    blockNumber\n    blockTimestamp\n    messageNonce\n    messageReceiver\n    messageReceiverChainID\n    messageSender\n    messageSenderChainID\n    transactionHash\n    transactionOrigin\n    status\n  }\n}\n    "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetExecutedMessageByTransactionHash($hash: Bytes) {\n  executedMessages(where: {transactionHash: $hash}) {\n    id\n    version\n    msgHash\n    message\n    messageData\n    blockNumber\n    blockTimestamp\n    messageNonce\n    messageReceiver\n    messageReceiverChainID\n    messageSender\n    messageSenderChainID\n    transactionHash\n    transactionOrigin\n    status\n  }\n}\n    "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetExecutedMessageByMessageHash($hash: Bytes) {\n  executedMessages(where: {msgHash: $hash}) {\n    id\n    version\n    msgHash\n    message\n    messageData\n    blockNumber\n    blockTimestamp\n    messageNonce\n    messageReceiver\n    messageReceiverChainID\n    messageSender\n    messageSenderChainID\n    transactionHash\n    transactionOrigin\n    status\n  }\n}\n    "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetRecentHeadUpdates($sourceChain: BigInt, $first: Int, $skip: Int) {\n  headUpdates(\n    where: {chainId: $sourceChain}\n    orderBy: blockTimestamp\n    orderDirection: desc\n    first: $first\n    skip: $skip\n  ) {\n    id\n    slot\n    root\n    transactionHash\n    transactionOrigin\n    blockNumber\n    blockTimestamp\n    address\n    chainId\n  }\n}\n    "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetHeadUpdatesBefore($sourceChain: BigInt, $blockNumber: BigInt, $first: Int) {\n  headUpdates(\n    orderBy: blockTimestamp\n    orderDirection: desc\n    where: {blockNumber_lt: $blockNumber, chainId: $sourceChain}\n    first: $first\n  ) {\n    id\n    slot\n    root\n    transactionHash\n    transactionOrigin\n    blockNumber\n    blockTimestamp\n    address\n    chainId\n  }\n}\n    "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n    query GetAllTimeSourceMetrics {\n  allTimeSourceData(id: "0") {\n    totalSentBytes\n    totalSentMessages\n  }\n}\n    '
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetRecentSourceMetrics($count: Int) {\n  dailySourceDatas(first: $count, orderBy: id, orderDirection: desc) {\n    id\n    dailySentBytes\n    dailySentMessages\n  }\n}\n    "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetRecentDestinationMetrics($count: Int) {\n  dailyTargetDatas(first: $count, orderBy: id, orderDirection: desc) {\n    id\n    dailyReceivedBytes\n    dailyReceivedMessages\n  }\n}\n    "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}













const baseDir = path_browserify_default().join(path_browserify_default().dirname((0,fileURLToPath/* fileURLToPath */.X)("file:///vercel/path0/.graphclient/index.ts")), "..");
const importFn = (moduleId)=>{
    const relativeModuleId = (path_browserify_default().isAbsolute(moduleId) ? path_browserify_default().relative(baseDir, moduleId) : moduleId).split("\\").join("/").replace(baseDir + "/", "");
    switch(relativeModuleId){
        case ".graphclient/sources/TelepathyRouter/introspectionSchema":
            return __webpack_require__.e(/* import() */ 267).then(__webpack_require__.bind(__webpack_require__, 40267));
        default:
            return Promise.reject(new Error("Cannot find module '".concat(relativeModuleId, "'.")));
    }
};
const rootStore = new store_esm/* MeshStore */.bn(".graphclient", new store_esm/* FsStoreStorageAdapter */.wH({
    cwd: baseDir,
    importFn,
    fileType: "ts"
}), {
    readonly: true,
    validate: false
});
const rawServeConfig = (/* unused pure expression or super */ null && (undefined));
async function getMeshOptions() {
    const pubsub = new esm_pubsub/* PubSub */.p();
    const sourcesStore = rootStore.child("sources");
    const logger = new esm_logger/* DefaultLogger */.Mn("GraphClient");
    const cache = new esm/* default */.Z({
        ...{},
        importFn,
        store: rootStore.child("cache"),
        pubsub,
        logger
    });
    const sources = [];
    const transforms = [];
    const additionalEnvelopPlugins = [];
    const telepathyRouterTransforms = [];
    const additionalTypeDefs = [];
    const telepathyRouterHandler = new graphql_esm/* default */.Z({
        name: "TelepathyRouter",
        config: {
            "endpoint": "https://api.thegraph.com/subgraphs/name/{context.subgraphName:succinctlabs/telepathy-goerli}"
        },
        baseDir,
        cache,
        pubsub,
        store: sourcesStore.child("TelepathyRouter"),
        logger: logger.child("TelepathyRouter"),
        importFn
    });
    sources[0] = {
        name: "TelepathyRouter",
        handler: telepathyRouterHandler,
        transforms: telepathyRouterTransforms
    };
    const additionalResolvers = [];
    const merger = new merger_bare_esm/* default */.Z({
        cache,
        pubsub,
        logger: logger.child("bareMerger"),
        store: rootStore.child("bareMerger")
    });
    return {
        sources,
        transforms,
        additionalTypeDefs,
        additionalResolvers,
        cache,
        pubsub,
        merger,
        logger,
        additionalEnvelopPlugins,
        get documents () {
            return [
                {
                    document: GetSentMessageByMessageNumberDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetSentMessageByMessageNumberDocument);
                    },
                    location: "GetSentMessageByMessageNumberDocument.graphql"
                },
                {
                    document: GetSentMessageByTransactionHashDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetSentMessageByTransactionHashDocument);
                    },
                    location: "GetSentMessageByTransactionHashDocument.graphql"
                },
                {
                    document: GetSentMessageByMessageHashDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetSentMessageByMessageHashDocument);
                    },
                    location: "GetSentMessageByMessageHashDocument.graphql"
                },
                {
                    document: GetSentMessagesDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetSentMessagesDocument);
                    },
                    location: "GetSentMessagesDocument.graphql"
                },
                {
                    document: GetExecutedMessagesDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetExecutedMessagesDocument);
                    },
                    location: "GetExecutedMessagesDocument.graphql"
                },
                {
                    document: GetExecutedMessageByMessageNumberDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetExecutedMessageByMessageNumberDocument);
                    },
                    location: "GetExecutedMessageByMessageNumberDocument.graphql"
                },
                {
                    document: GetExecutedMessageByTransactionHashDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetExecutedMessageByTransactionHashDocument);
                    },
                    location: "GetExecutedMessageByTransactionHashDocument.graphql"
                },
                {
                    document: GetExecutedMessageByMessageHashDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetExecutedMessageByMessageHashDocument);
                    },
                    location: "GetExecutedMessageByMessageHashDocument.graphql"
                },
                {
                    document: GetRecentHeadUpdatesDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetRecentHeadUpdatesDocument);
                    },
                    location: "GetRecentHeadUpdatesDocument.graphql"
                },
                {
                    document: GetHeadUpdatesBeforeDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetHeadUpdatesBeforeDocument);
                    },
                    location: "GetHeadUpdatesBeforeDocument.graphql"
                },
                {
                    document: GetAllTimeSourceMetricsDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetAllTimeSourceMetricsDocument);
                    },
                    location: "GetAllTimeSourceMetricsDocument.graphql"
                },
                {
                    document: GetRecentSourceMetricsDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetRecentSourceMetricsDocument);
                    },
                    location: "GetRecentSourceMetricsDocument.graphql"
                },
                {
                    document: GetRecentDestinationMetricsDocument,
                    get rawSDL () {
                        return (0,parseAndPrintWithCache/* printWithCache */.gJ)(GetRecentDestinationMetricsDocument);
                    },
                    location: "GetRecentDestinationMetricsDocument.graphql"
                }
            ];
        },
        fetchFn: global_ponyfill/* fetch */.he
    };
}
function createBuiltMeshHTTPHandler() {
    return createMeshHTTPHandler({
        baseDir,
        getBuiltMesh: getBuiltGraphClient,
        rawServeConfig: undefined
    });
}
let meshInstance$;
function getBuiltGraphClient() {
    if (meshInstance$ == null) {
        meshInstance$ = getMeshOptions().then((meshOptions)=>(0,get_mesh/* getMesh */.X)(meshOptions)).then((mesh)=>{
            const id = mesh.pubsub.subscribe("destroy", ()=>{
                meshInstance$ = undefined;
                mesh.pubsub.unsubscribe(id);
            });
            return mesh;
        });
    }
    return meshInstance$;
}
const execute = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return getBuiltGraphClient().then((param)=>{
        let { execute  } = param;
        return execute(...args);
    });
};
const subscribe = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return getBuiltGraphClient().then((param)=>{
        let { subscribe  } = param;
        return subscribe(...args);
    });
};
function getBuiltGraphSDK(globalContext) {
    const sdkRequester$ = getBuiltGraphClient().then((param)=>{
        let { sdkRequesterFactory  } = param;
        return sdkRequesterFactory(globalContext);
    });
    return getSdk(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return sdkRequester$.then((sdkRequester)=>sdkRequester(...args));
    });
}
const GetSentMessageByMessageNumberDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject());
const GetSentMessageByTransactionHashDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject1());
const GetSentMessageByMessageHashDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject2());
const GetSentMessagesDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject3());
const GetExecutedMessagesDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject4());
const GetExecutedMessageByMessageNumberDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject5());
const GetExecutedMessageByTransactionHashDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject6());
const GetExecutedMessageByMessageHashDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject7());
const GetRecentHeadUpdatesDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject8());
const GetHeadUpdatesBeforeDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject9());
const GetAllTimeSourceMetricsDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject10());
const GetRecentSourceMetricsDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject11());
const GetRecentDestinationMetricsDocument = (0,parseAndPrintWithCache/* gql */.Ps)(_templateObject12());
function getSdk(requester) {
    return {
        GetSentMessageByMessageNumber (variables, options) {
            return requester(GetSentMessageByMessageNumberDocument, variables, options);
        },
        GetSentMessageByTransactionHash (variables, options) {
            return requester(GetSentMessageByTransactionHashDocument, variables, options);
        },
        GetSentMessageByMessageHash (variables, options) {
            return requester(GetSentMessageByMessageHashDocument, variables, options);
        },
        GetSentMessages (variables, options) {
            return requester(GetSentMessagesDocument, variables, options);
        },
        GetExecutedMessages (variables, options) {
            return requester(GetExecutedMessagesDocument, variables, options);
        },
        GetExecutedMessageByMessageNumber (variables, options) {
            return requester(GetExecutedMessageByMessageNumberDocument, variables, options);
        },
        GetExecutedMessageByTransactionHash (variables, options) {
            return requester(GetExecutedMessageByTransactionHashDocument, variables, options);
        },
        GetExecutedMessageByMessageHash (variables, options) {
            return requester(GetExecutedMessageByMessageHashDocument, variables, options);
        },
        GetRecentHeadUpdates (variables, options) {
            return requester(GetRecentHeadUpdatesDocument, variables, options);
        },
        GetHeadUpdatesBefore (variables, options) {
            return requester(GetHeadUpdatesBeforeDocument, variables, options);
        },
        GetAllTimeSourceMetrics (variables, options) {
            return requester(GetAllTimeSourceMetricsDocument, variables, options);
        },
        GetRecentSourceMetrics (variables, options) {
            return requester(GetRecentSourceMetricsDocument, variables, options);
        },
        GetRecentDestinationMetrics (variables, options) {
            return requester(GetRecentDestinationMetricsDocument, variables, options);
        }
    };
}

;// CONCATENATED MODULE: ./src/lib/graphSDK.ts

// set context type for type checking
const graphSDK = getBuiltGraphSDK();


/***/ }),

/***/ 57448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getSubgraphName; }
/* harmony export */ });
/* unused harmony export SUBGRAPHS */
const SUBGRAPHS = {
    mainnet: "succinctlabs/telepathy-mainnet",
    goerli: "succinctlabs/telepathy-goerli",
    gnosis: "succinctlabs/telepathy-gnosis",
    arbitrum: "succinctlabs/telepathy-arbitrum",
    binance: "succinctlabs/telepathy-binance",
    polygon: "succinctlabs/telepathy-polygon",
    optimism: "succinctlabs/telepathy-optimism",
    avalanche: "succinctlabs/telepathy-avalanche"
};
function getSubgraphName(chain) {
    if (chain === undefined) {
        throw new Error("Chain undefined");
    }
    const name = SUBGRAPHS[chain];
    if (name === undefined) {
        throw new Error("Subgraph for ".concat(chain, " not configured"));
    }
    return name;
}


/***/ }),

/***/ 16772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OV": function() { return /* binding */ shorten; },
/* harmony export */   "Rm": function() { return /* binding */ formatDateUTC; },
/* harmony export */   "ab": function() { return /* binding */ arraySetEquality; },
/* harmony export */   "cG": function() { return /* binding */ getTailwindColor; }
/* harmony export */ });
/* unused harmony export shortenNumber */
/* harmony import */ var _tailwind_config_cjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9412);
/* harmony import */ var _tailwind_config_cjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tailwind_config_cjs__WEBPACK_IMPORTED_MODULE_0__);
var ref, ref1;

function shorten(value, left, right) {
    return value.slice(0, left) + "…" + value.slice(value.length - right);
}
const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
// Returns a day of month ex. Jan 1 in UTC
function formatDateUTC(date) {
    var ref;
    return date === undefined || date === null || !(date instanceof Date) || !isFinite(date.valueOf()) || date.getUTCDate() % 2 === 1 ? "" : ((ref = months[date.getUTCMonth()]) === null || ref === void 0 ? void 0 : ref.slice(0, 3)) + " " + date.getUTCDate();
}
// Returns whether two arrays have the same members
function arraySetEquality(left, right) {
    left.sort();
    right.sort();
    return left.length === right.length && left.every((val, idx)=>val === right[idx]);
}
function shortenNumber(val) {
    const min = 1e3;
    // Alter numbers larger than 1k
    if (val >= min) {
        const units = [
            "K",
            "M",
            "B",
            "T"
        ];
        let order = Math.min(Math.floor(Math.log(val) / Math.log(1000)), units.length);
        let unitname = units[order - 1];
        let num = Math.floor(val / 1000 ** order);
        // output number remainder + unitname
        return num + unitname;
    }
    // return formatted original number
    return val.toLocaleString();
}
const colors = (ref = (_tailwind_config_cjs__WEBPACK_IMPORTED_MODULE_0___default().theme)) === null || ref === void 0 ? void 0 : (ref1 = ref.extend) === null || ref1 === void 0 ? void 0 : ref1.colors;
function getTailwindColor(color) {
    const keys = color.split(".");
    let colorObj = colors;
    for (const key of keys){
        colorObj = colorObj[key];
    }
    return colorObj;
}


/***/ }),

/***/ 21103:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 9412:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

const colors = __webpack_require__(69808);
/** @type {import('tailwindcss').Config} */ module.exports = {
    content: [
        "./src/**/*.{js,ts,jsx,tsx}"
    ],
    theme: {
        fontFamily: {
            "sans-regular": [
                "FavoritNormal",
                "ui-sans-serif",
                "system-ui"
            ],
            "sans-book": [
                "FavoritBook",
                "ui-sans-serif",
                "system-ui"
            ],
            "sans-light": [
                "FavoritLight",
                "ui-sans-serif",
                "system-ui"
            ],
            sans: [
                "FavoritNormal",
                "ui-sans-serif",
                "system-ui"
            ],
            mono: [
                "IBMPlexRegular",
                "ui-monospace",
                "monospace",
                "system-ui"
            ]
        },
        extend: {
            colors: {
                transparent: "transparent",
                succinct: {
                    blue: "#0E283D",
                    black: "#050E16",
                    white: "#FFFFFF",
                    teal: "#C3DFE0",
                    "teal-5": "#0F1820",
                    "teal-10": "#18232A",
                    "teal-20": "#2B383E",
                    "teal-30": "#3E4D53",
                    "teal-40": "#516267",
                    "teal-50": "#64767B",
                    "teal-60": "#778B8F",
                    "teal-70": "#8AA0A3",
                    "teal-80": "#9DB5B8",
                    "teal-90": "#B0CACC",
                    "teal-100": "#C3DFE0",
                    neon: "#E8FE56",
                    orange: "#FE6535"
                }
            },
            keyframes: {
                "pulse-dark": {
                    "0%, 100%": {
                        opacity: 1
                    },
                    "50%": {
                        opacity: 0
                    }
                },
                shimmer: {
                    "100%": {
                        transform: "translateX(100%)"
                    }
                }
            },
            boxShadow: {
                "top-light": "0px 3px 0px #33296b, 0px 1px 15px rgba(0,0,0,.4)"
            },
            backgroundImage: {
                "purple-gradient": "linear-gradient( linear, left bottom, left top, color-stop(0, #3e2ba3), color-stop(1, #7463cb) )"
            }
        }
    },
    plugins: []
};


/***/ })

}]);